import { Dispatch } from "redux";

import { StatusStateAction } from "@reducers/types/taskManagement/settings/status-state";

import {
  GET_TM_SETTINGS_STATUS,
  GET_SINGLE_TM_SETTINGS_STATUS,
  CREATE_TM_SETTINGS_STATUS,
  UPDATE_TM_SETTINGS_STATUS,
  DELETE_TM_SETTINGS_STATUS,
} from "./types";

import { StatusCreateType } from "@type/taskManagement/settings/status";

import {
  fetchStatus,
  fetchStatusById,
  createStatus,
  updateStatus,
  deleteStatus,
} from "@api/taskManagement/settings/status";

export const statusFetchActionHandler =
  (query: any) => async (dispatch: Dispatch<StatusStateAction>) => {
    dispatch({ type: GET_TM_SETTINGS_STATUS.LOADING, payload: true });

    try {
      const res = await fetchStatus(query);

      const { statuses, page, size, total } = res.data || {};

      dispatch({
        type: GET_TM_SETTINGS_STATUS.SUCCESS,
        payload: {
          data: statuses,
          pagination: {
            page: page || 0,
            size: size || 0,
            total: total || 0,
          },
        },
      });
    } catch (err) {
      dispatch({ type: GET_TM_SETTINGS_STATUS.ERROR, payload: err });
    }
  };

export const statusByIdFetchActionHandler =
  (id: string | number) => async (dispatch: Dispatch<StatusStateAction>) => {
    dispatch({ type: GET_SINGLE_TM_SETTINGS_STATUS.LOADING, payload: true });

    try {
      const res = await fetchStatusById(id);

      dispatch({
        type: GET_SINGLE_TM_SETTINGS_STATUS.SUCCESS,
        payload: res.data || {},
      });
    } catch (err) {
      dispatch({ type: GET_SINGLE_TM_SETTINGS_STATUS.ERROR, payload: err });
    }
  };

export const statusCreateActionHandler =
  (data: StatusCreateType) => async (dispatch: Dispatch<StatusStateAction>) => {
    dispatch({ type: CREATE_TM_SETTINGS_STATUS.LOADING, payload: true });

    try {
      const res = await createStatus(data);

      dispatch({ type: CREATE_TM_SETTINGS_STATUS.SUCCESS, payload: res.data });
    } catch (err) {
      dispatch({ type: CREATE_TM_SETTINGS_STATUS.ERROR, payload: err });
    }
  };

export const statusUpdateActionHandler =
  (id: string | number, data: StatusCreateType) =>
  async (dispatch: Dispatch<StatusStateAction>) => {
    dispatch({ type: UPDATE_TM_SETTINGS_STATUS.LOADING, payload: true });

    try {
      const res = await updateStatus(id, data);

      dispatch({
        type: UPDATE_TM_SETTINGS_STATUS.SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({ type: UPDATE_TM_SETTINGS_STATUS.ERROR, payload: err });
    }
  };

export const statusDeleteActionHandler =
  (id: string | number) => async (dispatch: Dispatch<StatusStateAction>) => {
    dispatch({ type: DELETE_TM_SETTINGS_STATUS.LOADING, payload: true });

    try {
      const res = await deleteStatus(id);

      dispatch({ type: DELETE_TM_SETTINGS_STATUS.SUCCESS, payload: res.data });
    } catch (err) {
      dispatch({ type: DELETE_TM_SETTINGS_STATUS.ERROR, payload: err });
    }
  };
